<template>
  <div class="layout">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="国内市场布局" name="1">
        <layoutin />
      </el-tab-pane>
      <el-tab-pane label="海外市场布局" name="2">
        <layoutout />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import layoutin from "./layoutin.vue";
import layoutout from "./layoutout.vue";
export default {
  components: { layoutin, layoutout },
  data() {
    return {
      activeName: "1",
    };
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style scoped lang="less">
.layout {
  .el-tab-pane {
    width: 100%;
    overflow: hidden;
  }
  ::v-deep .el-tabs__nav-scroll {
    width: 100%;
    justify-content: left;
    border-bottom: 0.05vw solid rgba(209, 213, 217, 0.6784);
    padding-left: 1.04vw;
    padding-right: 1.56vw;
  }
  ::v-deep .el-tabs__active-bar {
    height: 0.16vw !important;
    border-radius: 0.21vw 0.21vw 0 0;
  }
  // height: 44.79vw;
  padding: 0.83vw 0 2.6vw 0;
}
::v-deep .el-tabs__nav-wrap::after {
  width: 0;
}
::v-deep .el-tabs__item {
  font-size: 0.83vw;
}
::v-deep .el-tabs__item.is-active {
  font-size: 0.94vw;
  color: #1961ac;
}
::v-deep .el-tabs__header {
  padding: 0 1.56vw;
}
::v-deep .el-tabs__active-bar {
  background-color: #1961ac;
}
</style>
